import { render, staticRenderFns } from "./GenderRatioModal.vue?vue&type=template&id=4f901526&scoped=true&"
import script from "./GenderRatioModal.vue?vue&type=script&lang=js&"
export * from "./GenderRatioModal.vue?vue&type=script&lang=js&"
import style0 from "./GenderRatioModal.vue?vue&type=style&index=0&id=4f901526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f901526",
  null
  
)

export default component.exports